import type { QueryClient } from '@tanstack/react-query';
import {
  getGetAdminInvoiceReportPaymentInfoQueryKey,
  getGetAdminInvoiceReportSummaryQueryKey,
} from 'ap-openapi';

/**
 * Invalidates admin invoice report detail queries for a specific report
 * @param queryClient - The React Query client instance
 * @param reportId - The ID of the report to invalidate queries for
 */
export const invalidateAdminInvoiceReportDetailQueries = (
  queryClient: QueryClient,
  reportId: string
): void => {
  queryClient.invalidateQueries({
    queryKey: getGetAdminInvoiceReportSummaryQueryKey(reportId),
  });
  queryClient.invalidateQueries({
    queryKey: getGetAdminInvoiceReportPaymentInfoQueryKey(reportId),
  });
  queryClient.invalidateQueries({
    queryKey: ['adminInvoiceReportJournalEntries', reportId],
  });
  queryClient.invalidateQueries({
    queryKey: ['adminInvoiceReportApprovalRoute', reportId],
  });
};
